import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, fonts, mixins } from "@similarweb/styles";

import EditableText from "app/pages/sales-intelligence/common-components/EditableText/EditableText";
import {
    StyledInput,
    StyledInputContainer,
    StyledText,
} from "app/pages/sales-intelligence/common-components/EditableText/styles";

export const StyledHeaderToggleIconWrap = styled.div`
    margin-right: 12px;
`;

export const StyledToggleSwitchWrap = styled.div`
    flex-shrink: 0;
    padding-left: 8px;

    & > div {
        margin-right: 0;
    }
`;

export const StyledDeleteIconWrap = styled.div`
    visibility: hidden;
`;

export const StyledHeaderControls = styled.div`
    align-items: center;
    display: flex;
    flex-shrink: 0;
    margin-left: 4px;
`;

export const StyledEditIconWrap = styled.div`
    margin-left: 12px;
    visibility: hidden;

    & ${SWReactIcons} svg path {
        fill-opacity: 1;
    }
`;

export const StyledEditableText = styled(EditableText)<{ overflow?: boolean }>`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: ${({ overflow }) => (overflow ? "hidden" : "visible")};

    & ${StyledText}, & ${StyledInputContainer} ${StyledInput} {
        ${mixins.setFont({
            $color: colorsPalettes.carbon["400"],
            $family: fonts.$dmSansFontFamily,
            $size: 14,
            $weight: 500,
        })};
    }

    & ${StyledText} {
        display: inline-block;
        max-width: 100%;
        vertical-align: middle;
    }
`;

export const StyledHeaderLeftInner = styled.div<{ overflow?: boolean }>`
    align-items: center;
    display: flex;
    overflow: ${({ overflow }) => (overflow ? "hidden" : "visible")};
`;

export const StyledHeaderLeft = styled(StyledHeaderLeftInner)<{ overflow?: boolean }>`
    overflow: ${({ overflow }) => (overflow ? "hidden" : "visible")};
`;

export const StyledHeaderInner = styled.div`
    align-items: center;
    background-color: transparent;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: space-between;
    padding: 0 16px 0 12px;
    transition: background-color 200ms ease-in-out;
    user-select: none;
    width: 100%;

    &:hover {
        & ${StyledDeleteIconWrap}, & ${StyledEditIconWrap} {
            visibility: visible;
        }
    }
`;

export const StyledHeader = styled.div`
    background-color: ${colorsPalettes.carbon["0"]};
    box-sizing: border-box;
    cursor: default;
    height: 40px;
    padding: 0;
    position: relative;
    transition: background-color 500ms ease-in-out;
`;
